/**
 * 保存自定义字段为公共字段服务
 */
export const SaveCustomFieldAsPublicService = Symbol('SaveCustomFieldAsPublicService');
